import { InventoryLogDataDto } from "./InventoryLogsDto";
import { InventoryLogDataModel } from "./InventoryLogsModel";

export const transformInventoryLogsDtoToModel = (
  dto: InventoryLogDataDto
): InventoryLogDataModel => dto;
